import { useCallback, useState } from "react";
import i18next from "i18next";
import ModalGallery from "../components/Modal/ModalGallery";
import { useDispatchApp } from "../lib/redux";
import { getPathDatabaseByRole } from "../actions/auth";
import { getLanguageFormatted } from "../utils/string";
import {
  ADS_CAMPAIGN_CAROUSEL_FORMAT,
  IMAGE_FORMATS,
  VIDEO_FORMATS,
} from "../utils/constants";
import { PENDING_CONTENT_APPROVAL_REVIEW_STORAGE_KEY } from "../components/ContentApproval/contentApprovalUtils";

const useOutsideCampaignGallery = () => {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [initialContentReviewID, setInitialContentReviewID] = useState(null);

  const dispatch = useDispatchApp();
  const { userID } = dispatch(getPathDatabaseByRole());
  const language = getLanguageFormatted(i18next.language);

  const onOpenGallery = useCallback(() => {
    const pendingContentID = sessionStorage.getItem(
      PENDING_CONTENT_APPROVAL_REVIEW_STORAGE_KEY
    );

    if (pendingContentID) {
      sessionStorage.removeItem(PENDING_CONTENT_APPROVAL_REVIEW_STORAGE_KEY);
      setInitialContentReviewID(pendingContentID);
    }

    setIsGalleryOpen(true);
  }, []);

  const onCloseGallery = useCallback(() => {
    setInitialContentReviewID(null);
    setIsGalleryOpen(false);
  }, []);

  const onInitialContentReviewConsumed = useCallback(() => {
    setInitialContentReviewID(null);
  }, []);

  const galleryModal = isGalleryOpen ? (
    <ModalGallery
      modalOpen={isGalleryOpen}
      onCloseModal={onCloseGallery}
      multiple={true}
      isOutsideCampaign={true}
      acceptedFormats={IMAGE_FORMATS.concat(VIDEO_FORMATS).concat(
        ADS_CAMPAIGN_CAROUSEL_FORMAT
      )}
      pathStorage={`socialMedia/${userID}/`}
      modeUpload="sync"
      onCallbackSelectedItems={() => {}}
      closeActionsDisabled={true}
      initialValues={{ language }}
      initialContentReviewID={initialContentReviewID}
      onInitialContentReviewConsumed={onInitialContentReviewConsumed}
    />
  ) : null;

  return {
    isGalleryOpen,
    onOpenGallery,
    onCloseGallery,
    galleryModal,
  };
};

export default useOutsideCampaignGallery;
